import TitleM from "@common/components/text/TitleM"
import { HeaderContainerM } from "@common/header/HeaderContainerM"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { skillSetsService } from "@data/services/skillSetsService"
import { useNavigation } from "@react-navigation/native"
import { StatusBar } from "@common/systemBars/StatusBar"
import React, { useContext, useEffect } from "react"
import {
    Dimensions,
    Platform,
    RefreshControl,
    ScrollView,
    TouchableOpacity,
    View,
} from "react-native"
import { IconButton } from "react-native-paper"
import { connect } from "react-redux"
import SkillItem from "./SkillItem"

const MySkillSetsTabScreen = (props) => {
    useEffect(() => {
        props.apiRequest(skillSetsService.getSkillSets)
    }, [])

    useApiStatus(skillSetsService.getSkillSets, null, true, () => {})

    const navigation = useNavigation()
    const skillSetsList = props.user?.skill_sets

    const skills = props.skills
    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                backgroundColor: theme.colors.whiteAlmost,
                flex: 1,
            }}
        >
            <View
                style={{
                    flex: 1,
                    width: Dimensions.get("window").width,
                    backgroundColor: theme.colors.whiteAlmost,
                    alignItems: "center",
                    justifyContent: "flex-start",
                    alignSelf: "center",
                }}
            >
                <HeaderContainerM
                    style={{
                        justifyContent: "center",
                        paddingRight: 15,
                        flexDirection: "row",
                    }}
                >
                    <IconButton
                        icon={"times"}
                        iconColor={theme.colors.primary}
                        containerColor={theme.colors.transparent}
                        size={30}
                        style={{
                            position: "absolute",
                            left: 4,
                        }}
                        onPress={() => {
                            if (navigation.canGoBack()) navigation.goBack()
                            else navigation.replace("menu")
                        }}
                    />
                    <TitleM
                        fontWeight="ExtraBold"
                        style={{ textAlign: "center", marginBottom: 5 }}
                    >
                        MES QUÊTES
                    </TitleM>
                </HeaderContainerM>
                <ScrollView
                    contentContainerStyle={{
                        paddingHorizontal: 10,
                        paddingTop: 10,
                    }}
                    showsHorizontalScrollIndicator={false}
                    refreshControl={
                        <RefreshControl
                            refreshing={!!props.getSkillSetsRequest}
                            onRefresh={() =>
                                props.apiRequest(skillSetsService.getSkillSets)
                            }
                        />
                    }
                >
                    {skills && skillSetsList
                        ? skillSetsList?.map((s, index) => {
                              return (
                                  <View
                                      key={index}
                                      style={{
                                          flex: 1,
                                          borderWidth: 1,
                                          borderRadius: 15,
                                          backgroundColor: theme.colors.white,
                                          borderColor: theme.colors.lightMore,
                                          marginTop: 20,
                                      }}
                                  >
                                      <TouchableOpacity
                                          style={{
                                              marginTop: 10,
                                              width: IS_WEB
                                                  ? dimensions?.width / 1.2
                                                  : null,
                                          }}
                                          onPress={() => {
                                              navigation.push("skill-sets", {
                                                  skillSetId: s?.id,
                                              })
                                          }}
                                      >
                                          <SkillItem
                                              stepNum={s?.current_step}
                                              skillSet={s}
                                              withAnimation={false}
                                              active={true}
                                              width={90}
                                          />
                                      </TouchableOpacity>
                                  </View>
                              )
                          })
                        : ""}

                    <View
                        style={{
                            height: 100,
                        }}
                    />

                    {/*{IS_WEB && <FilledButtonM mode={"text"}*/}
                    {/*                          icon={"chevron-left"}*/}
                    {/*                          color={theme.colors.link}*/}
                    {/*                          style={{marginTop: 60}}*/}
                    {/*                          onPress={() => {*/}
                    {/*                              if (navigation.canGoBack())*/}
                    {/*                                  navigation.goBack()*/}
                    {/*                              else*/}
                    {/*                                  navigation.replace("menu")*/}
                    {/*                          }}*/}
                    {/*                          label={"Retour"}/>}*/}
                </ScrollView>

                <StatusBar
                    style="dark"
                    backgroundColor={theme.colors.white}
                    translucent={false}
                />
            </View>
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        getSkillSetsRequest: state.api.getSkillSets?.request,
        getSkillSetsSuccess: state.api.getSkillSets?.success,
        getSkillSetsError: state.api.getSkillSets?.error,
        successes: state.data.staticData?.successes,
        skill_sets: state.data.staticData?.skill_sets,
        skills: state.data.staticData?.skills,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MySkillSetsTabScreen)
